import { render } from "./SubmitOtpPage.vue?vue&type=template&id=5e9e45ce&scoped=true"
import script from "./SubmitOtpPage.vue?vue&type=script&lang=js"
export * from "./SubmitOtpPage.vue?vue&type=script&lang=js"

import "./SubmitOtpPage.vue?vue&type=style&index=0&id=5e9e45ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e9e45ce"]])

export default __exports__